<template>
  <header class="main-header z-10 website-header max-md:relative" :class="{ 'dark-mode': isDarkMode }" data-testid="main-header">
    <mobile-header :light="!isDarkMode" has-logo>
      <router-link to="/" data-testid="main-header-logo-mobile">
        <img src="@/assets/website/img/logo-light.svg" width="96" alt="" v-if="!isDarkMode">
        <img src="@/assets/logo.avif" width="96" alt="" v-else>
      </router-link>
    </mobile-header>
    <div class="max-md:hidden" data-testid="main-header-default-logo-container">
      <router-link to="/" class="main-header__logo" data-testid="main-header-logo-default">
        <img src="@/assets/website/img/logo-light.svg" width="108" alt="" v-if="!isDarkMode" data-testid="main-header-logo-image">
        <img src="@/assets/logo.avif" width="108" alt="" v-else data-testid="main-header-logo-image">
      </router-link>
    </div>
        <nav class="justify-end ml-auto items-center md:flex hidden" data-testid="main-header-navigation">
          <router-link to="/faq" class="nav-link text-19 !text-white/75 " active-class="active"
          data-testid="faq-title"
          >{{ $t('about_forum') !== 'about_forum' ? $t('about_forum') : 'About Forum'}}</router-link>
          <router-link to="/plans" class="nav-link !text-white/75 text-19" active-class="active" data-testid="pricing-title">{{ $t('pricing_title') }}</router-link>
          <a @click="openTermsPopup" class="nav-link cursor-pointer text-19 !text-white/75" active-class="active" data-testid="signin-title" v-if="!authorized">{{ $t('signin_title')}}/{{ $t('register_title')}}</a>
          <a @click="openAccountPopup" class="nav-link text-19 !text-white/75 cursor-pointer" active-class="active" data-testid="account-title" v-else>
            <img src="@/assets/icons/account-icon.svg" alt="Account" class="h-[20px] w-[20px] mr-1 inline-block align-middle">
            {{ $t('profile_title')}}
          </a>
        </nav>
      </header>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import emitter from "@/services/emitter.service";
import MobileHeader from "@/components/MobileHeader.vue";

export default {
  name: 'MainHeader',
  components: {
    MobileHeader,
  },
  props: {
    isDarkMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openBeacon() {
      window.Beacon('open');
    },
    openGetStartedModal() {
      emitter.emit('open-auth0');
    },
    openAccountPopup() {
      emitter.emit('open-account-popup');
    },
    openTermsPopup() {
      emitter.emit('open-terms-agreement-modal');
    },
  },
  computed: {
     ...mapState('auth', ['token', 'authorized']),
  },
}
</script>

<style lang="scss">
    .wrapper {
        justify-content: flex-start !important;
    }

  .main-header {
    padding: 40px 40px 32px 40px;
    display: flex;
    justify-content: space-between;

    &__logo {
      position: relative;
      z-index: 10;
    }

    &.dark-mode {
      color: #FFFFFF;

      a {
        color: #FFFFFF;
      }
    }
  }

  @media all and (max-width: 800px) {
    .main-header {
      padding: 40px 24px 32px 24px;
    }
  }

  .website-nav {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    align-items: center;

    a {
      margin-left: 75px;
      font-weight: 300;
      font-size: 1.3rem;
      line-height: 2rem;
      /* identical to box height */
      text-align: center;
      text-transform: uppercase;

      color: #979797;

      &:first-child {
        margin-left: 0;
      }

      &.orange-link, &:hover{
        color: #6CBFFF;
        display: inline;
      }

      &.active {
        color: #6CBFFF;
        font-weight: 700;
      }

      @media all and (max-width: 1400px) {
        font-size: 1rem;
        margin-left: 55px;
      }
    }
  }
</style>
